import { render, staticRenderFns } from "./ProductColour.vue?vue&type=template&id=c63fe1b8&"
import script from "./ProductColour.vue?vue&type=script&lang=js&"
export * from "./ProductColour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports